// extracted by mini-css-extract-plugin
module.exports = {"section":"NotificationsSection_section__3nwKO","column1":"NotificationsSection_column1__1Mcml","column2":"NotificationsSection_column2__q4wB4"};